/**
 * <flex-qty-breaks> — Mengenstaffel-Kacheln auf der PDP (Koala-Ersatz).
 * Kachel-Klick setzt das Mengenfeld des Kauf-Formulars; manuelle
 * Mengenänderung markiert die höchste erreichte Stufe. Custom Element,
 * damit es Dawns Section-Re-Render beim Variantenwechsel übersteht.
 */
class FlexQtyBreaks extends HTMLElement {
  connectedCallback() {
    if (this.dataset.init) return;
    this.dataset.init = "1";
    this.tiers = [...this.querySelectorAll(".flex-qb__tier")];

    this.addEventListener("change", (e) => {
      const radio = e.target.closest('input[type="radio"]');
      if (!radio) return;
      this.qtyInput = this.findQtyInput();
      if (!this.qtyInput) return;
      const min = Math.max(1, parseInt(radio.value, 10) || 1);
      const current = parseInt(this.qtyInput.value, 10) || 1;
      // Stufen-Klick setzt die Menge EXAKT auf die Mindestmenge der Stufe —
      // in beide Richtungen (Nico 28.08.: bei 10 im Feld setzt "Ab 5" auf 5).
      if (current !== min) {
        this.qtyInput.value = String(min);
        this.qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
      this.markActive(min);
    });

    // Mengenfeld-Änderungen delegiert beobachten (Feld kann nach uns im DOM
    // erscheinen oder von Dawn neu gerendert werden).
    this.qtyListener = (e) => {
      if (!e.target.matches || !e.target.matches('input[name="quantity"]')) return;
      this.markActive(parseInt(e.target.value, 10) || 1);
    };
    document.addEventListener("change", this.qtyListener);
    document.addEventListener("input", this.qtyListener);
    const init = this.findQtyInput();
    if (init) this.markActive(parseInt(init.value, 10) || 1);
  }

  disconnectedCallback() {
    if (this.qtyListener) {
      document.removeEventListener("change", this.qtyListener);
      document.removeEventListener("input", this.qtyListener);
    }
  }

  findQtyInput() {
    const form = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    return form || document.querySelector('quantity-input input[name="quantity"]');
  }

  markActive(qty) {
    let active = null;
    for (const tier of this.tiers) {
      const min = parseInt(tier.querySelector("input").value, 10) || 1;
      if (qty >= min) active = tier;
    }
    this.tiers.forEach((t) => {
      const on = t === active;
      t.classList.toggle("is-active", on);
      // Unterhalb der ersten Stufe ist KEINE Zeile aktiv — Radios explizit
      // leeren (Radio-Gruppen räumen sich nicht von selbst auf).
      t.querySelector("input").checked = on;
    });
  }
}
if (!customElements.get("flex-qty-breaks")) {
  customElements.define("flex-qty-breaks", FlexQtyBreaks);
}
